import React from 'react';
import { FormattedMessage } from 'react-intl';
import VitalItemHeader from './vital-item-header';
import { VitalItemSC } from './vital-list.styled';
import { VitalChartEmpty } from '../vital-chart';

export type TVitalItemEmptyProps = {
  title: string;
  iconSrc: string;
};

const VitalItemEmpty: React.FC<TVitalItemEmptyProps> = ({ title, iconSrc }) => {
  return (
    <VitalItemSC>
      <VitalItemHeader icon={<img src={iconSrc} alt="" width="24" height="24" />} title={title} />
      <div className="vi-body">
        <div className="vi-chart-col">
          <VitalChartEmpty />
        </div>
        <div className="vi-data-col">
          <div className="vi-data-row">
            <span>
              <FormattedMessage id="life_id.state" />
            </span>
            <b>— —</b>
          </div>
          <div className="vi-data-row">
            <span>
              <FormattedMessage id="life_id.records" />
            </span>
            <b>— —</b>
          </div>
        </div>
      </div>
    </VitalItemSC>
  );
};

export default VitalItemEmpty;
